import Color from 'color';
import { Theme } from '.';

const colors = {
  primary: '#D2551F',
  secondary: '#F7CE46',
  success: '#10B981',
  warning: '#F59E0B',
  alert: '#EF4444',
  brand: '#011E41',
  white: '#ffffff',
  black: '#000000',
  grey: '#737373',
  gray: '#737373',
  overlay: 'rgba(0, 0, 0, 0.5)',
};

export const primaryColorMap = {
  900: "#2a1106",
  800: "#2a1106",
  700: "#2a1106",
  600: "#2a1106",
  500: "#D2551F",
  400: "#db774c",
  300: "#e49979",
  200: "#e49979",
  100: "#e49979",
  50: "#e49979"
}

export const colorLevelMap = {
  900: 0.8,
  800: 0.6,
  700: 0.4,
  600: 0.2,
  500: 0,
  400: 0.1,
  300: 0.3,
  200: 0.5,
  100: 0.7,
  50: 0.9,
};
export const greyColorMap = {
  900: '#18181B',
  800: '#27272A',
  700: '#3F3F46',
  600: '#52525B',
  500: '#71717A',
  400: '#A1A1AA',
  300: '#D4D4D8',
  200: '#E4E4E7',
  100: '#F4F4F5',
  50: '#FAFAFA',
};

const tint = (c: number, ratio: number) => c + (255 - c) * ratio;

export const getColorFromVar = (
  theme: Theme,
  key: string,
  level: number | undefined = undefined
): string => {
  const originalColor = theme.colors[key];
  if (!originalColor) return `#${key}`;
  if (!level || level == 500) return originalColor;

  if (key == 'grey' || key == 'gray') {
    return greyColorMap[level];
  }

  if(key == 'primary'){
    return primaryColorMap[level];
  }

  const color = Color(originalColor);
  const ratio = colorLevelMap[level];
  if (level > 500) {
    return color.darken(ratio).hex();
  } else {
    let [r, g, b]: number[] = color.rgb().array();
    if (
      typeof r != 'undefined' &&
      typeof g != 'undefined' &&
      typeof b != 'undefined'
    ) {
      return Color.rgb(tint(r, ratio), tint(g, ratio), tint(b, ratio)).hex();
    }
  }

  return originalColor;
};

export default colors;
